module.exports = "/fonts/Ki.woff?8f9a1a6cffbd1826644e12714ec106d0";